export default __webpack_public_path__ + "static/media/blog_inner_16.c1170ad9.jpg";